import { toast } from 'sonner';

let lastUndoCallback = null;

export const toasts = {
  // SUCCÈS — Library / Favoris
  trackLiked: () =>
    toast.success('Track ajoutée à vos favoris ❤️', { duration: 2000 }),
  trackUnliked: () => toast.success('Retirée des favoris', { duration: 2000 }),
  trackBanned: (title, undo) => {
    lastUndoCallback = undo;
    toast.success(`"${title}" bannie. Plus jamais jouée.`, {
      duration: 5000,
      action: { label: 'Annuler', onClick: () => lastUndoCallback?.() },
    });
  },
  trackUnbanned: () => toast.success('Track débannie', { duration: 2000 }),

  // SUCCÈS — Queue
  trackAddedToQueue: (title) =>
    toast.success(`"${title}" ajoutée à la file`, { duration: 2000 }),
  trackPlayedNext: (title) =>
    toast.success(`"${title}" jouée juste après`, { duration: 2000 }),
  queueRemoved: () =>
    toast.success('Track retirée de la file', { duration: 2000 }),
  queueCleared: () =>
    toast.success('File de lecture vidée', { duration: 2000 }),

  // SUCCÈS — Playlists
  playlistCreated: (name) => toast.success(`Playlist "${name}" créée`),
  playlistSaved: () => toast.success('Playlist sauvegardée'),
  playlistDeleted: () => toast.success('Playlist supprimée'),
  playlistRenamed: () => toast.success('Playlist renommée'),
  playlistLiked: (name, undoCb) =>
    toast.success(`"${name}" ajoutée à votre bibliothèque`, {
      duration: 6000,
      action: undoCb ? { label: 'Annuler', onClick: undoCb } : undefined,
    }),
  playlistUnliked: (name) =>
    toast.info(`"${name}" retirée de votre bibliothèque`),

  // SUCCÈS — Historique / Settings
  historyCleared: () => toast.success('Historique effacé'),
  settingsReset: () => toast.success('Paramètres réinitialisés'),
  certificateGenerated: () =>
    toast.success('Certificat de conformité généré 📄'),
  onboardingComplete: () =>
    toast.success('Configuration terminée ! Belle écoute 🎶', {
      duration: 3500,
    }),

  // ERREURS
  networkError: () =>
    toast.error('Connexion perdue. Réessaye dans un instant.', {
      duration: 4000,
    }),
  audioError: (title) =>
    toast.error(
      title ? `Impossible de lire "${title}". On la skippe.` : 'Erreur audio.',
      { duration: 4000 }
    ),
  audioBlocked: () =>
    toast.error("Touche l'écran pour autoriser l'audio (iOS).", {
      duration: 5000,
    }),
  playlistEmpty: () => toast.error('Aucune track dans cette playlist'),
  pinIncorrect: () => toast.error('Code PIN incorrect'),
  saveError: () =>
    toast.error('Sauvegarde impossible. Réessaye.', {
      action: { label: 'Réessayer', onClick: () => lastUndoCallback?.() },
    }),

  // INFO
  nowPlaying: (title) => toast.info(`En cours : ${title}`, { duration: 2000 }),
  cmdkHint: () =>
    toast.info('Astuce : ⌘K pour rechercher partout', { duration: 4000 }),

  // WARNING
  trialExpiring: (days) =>
    toast.warning(
      `Ton essai se termine dans ${days} jour${days > 1 ? 's' : ''}`,
      { duration: 6000 }
    ),

  // GENERIC
  info: (message, options) => toast.info(message, options),
};
